import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import { PettyCashierBudgetComparativeReportAction } from "../../actions";
import * as budgetComparativeReportApi from "../../api/pettyCashBudget/pettyCashierBudgetComparativeReport";
import { SetMessage } from "../../assets/errorMessages";

export function* watcherPettyCashierBudgetComparativeReport() {
  yield takeLatest(
    types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_REQUEST,
    workerPettyCashierBudget
  );
}

function fetchPettyCashierBudget() {
  return budgetComparativeReportApi.pettyCashierGetBudgetComparisonInfo();
}

function* workerPettyCashierBudget() {
  try {
    const response = yield call(fetchPettyCashierBudget);
    let data = response.data;
    yield put(
      PettyCashierBudgetComparativeReportAction.getBudgetComparisonInfoSuccess(
        data
      )
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(
      PettyCashierBudgetComparativeReportAction.getBudgetComparisonInfoFailure(
        message
      )
    );
  }
}
